// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"193":"d956bf86","283":"8441c232","462":"1e4f3a6d","810":"8d959c95","873":"5ad7833f"}[chunkId] + ".css";
};